import { render, staticRenderFns } from "./airSettingsDialog.vue?vue&type=template&id=6fe99688&scoped=true&"
import script from "./airSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./airSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe99688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe99688')) {
      api.createRecord('6fe99688', component.options)
    } else {
      api.reload('6fe99688', component.options)
    }
    module.hot.accept("./airSettingsDialog.vue?vue&type=template&id=6fe99688&scoped=true&", function () {
      api.rerender('6fe99688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airSettingsDialog.vue"
export default component.exports